import { Button } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'
import { CopyToClipboardIcon } from 'components/custom-icons'
import { PropsWithChildren } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'

const StyledWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${GTR.XXS};
`

const StyledButton = styled(Button.Plain)`
  padding: 0;
  display: inline-flex;
  align-items: center;

  &:not(:disabled):focus,
  &:not(:disabled):active {
    outline: none;
    box-shadow: none;
  }

  g {
    fill: ${COLOR.GREY.MEDIUM};
  }

  &:hover {
    g {
      fill: ${COLOR.BLACK};
    }
  }
`

const StyledCopyToClipboardIcon = styled(CopyToClipboardIcon)`
  transition: transform 0.2s ease-in-out;

  &:active {
    transform: translateY(-3px);
  }
`

type WithCopyToClipboardProps = PropsWithChildren<{
  value: string
  label: string
}>

export const WithCopyToClipboard = ({
  value,
  label,
  children,
}: WithCopyToClipboardProps) => {
  const handleCopyToClipboard = (e: React.MouseEvent) => {
    e.preventDefault()

    try {
      value && navigator.clipboard.writeText(value)
      toast(`${label} copied to clipboard.`, {
        toastId: `success-copy-to-clipboard-${value}`,
      })
    } catch (err) {
      toast(`Failed to copy ${label} to clipboard.`, {
        toastId: `failed-copy-to-clipboard-${value}`,
      })
    }
  }

  return (
    <StyledWrapper>
      {children}
      {value && (
        <StyledButton onClick={handleCopyToClipboard} type="button">
          <StyledCopyToClipboardIcon
            color={COLOR.BLACK}
            height="16px"
            viewBox="0 0 21 22"
            width="15px"
          />
        </StyledButton>
      )}
    </StyledWrapper>
  )
}
